"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var reactIntl=require("react-intl"),f=reactIntl.defineMessages({cancel:{defaultMessage:"Cancel",id:"app.components.ConfirmationModal.cancel"}});exports.default=f;
//# sourceMappingURL=messages.js.map
